import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CalendarView from "@/components/CalendarView";

export default function PMCalendar() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/jobs").then((r) => setJobs(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="pm-calendar">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">Calendar</h1>
        <p className="text-muted-foreground text-sm mt-1">All scheduled cleans across your properties.</p>
      </div>
      <CalendarView jobs={jobs} />
    </div>
  );
}
